._textEditor__pimple_dhq68_1 {
  position: absolute; }
